import { render, staticRenderFns } from "./rpd_menu.vue?vue&type=template&id=53da03c1&scoped=true&"
import script from "./rpd_menu.vue?vue&type=script&lang=js&"
export * from "./rpd_menu.vue?vue&type=script&lang=js&"
import style0 from "./rpd_menu.vue?vue&type=style&index=0&id=53da03c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53da03c1",
  null
  
)

export default component.exports